var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer"},[_c('radial',{attrs:{"completed-steps":_vm.completed,"total-steps":_vm.time,"start-color":"#B71E3F","stop-color":"#B71E3F","stroke-width":2,"indicator-size":12,"inner-stroke-color":"#fff"}}),_vm._v(" "),_c('h2',[_vm._v("Die Zeit läuft")]),_vm._v(" "),_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.showTime))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27ea0434","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timer.vue
// module id = null
// module chunks = 